import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Flex, useColorModeValue } from "@chakra-ui/react";

import {
  SERVICE_FORM_COMPONENTS_PER_TYPE,
  SERVICE_FORM_LEGENDS_PER_TYPE
} from "components/Condominiums/Services/ServiceForm/constants";
import { ServiceFormType } from "components/Condominiums/Services/ServiceForm/types";

export const SaveService = () => {
  const { serviceId } = useParams();
  const [type, setType] = useState<ServiceFormType>("create");

  const ServiceFormComponent = SERVICE_FORM_COMPONENTS_PER_TYPE[type];
  const ServiceFormLegendComponent = SERVICE_FORM_LEGENDS_PER_TYPE[
    type
  ];

  function setupForm() {
    if (serviceId) {
      setType("edit");
    }
  }

  useEffect(() => {
    setupForm();
  }, [serviceId]);

  return (
    <Flex
      bg={useColorModeValue("gray.50", "gray.800")}
      justifyContent={"left"}
      padding={5}
    >
      <Box width="100%">
        <Box textAlign={"left"} py={10} px={2}>
          <ServiceFormLegendComponent />
        </Box>
        <Box
          margin={2}
          display="flex"
          flexDirection={{
            base: "column-reverse",
            lg: "row"
          }}
          gap={10}
          justifyContent={{
            base: "center",
            lg: "space-between"
          }}
        >
          <ServiceFormComponent />
        </Box>
      </Box>
    </Flex>
  );
};
